import {
  formatAgentQuestionAnswerCopy,
  humanizeAgentQuestionSelection,
} from './formatAgentQuestionAnswerCopy.js'

/**
 * @param {string} prompt
 * @param {string} selectedAnswer
 * @param {string | undefined} kind
 */
export function buildAgentQuestionAnsweredBlocks(prompt, selectedAnswer, kind) {
  const question = String(prompt ?? '').trim()
  const reply = formatAgentQuestionAnswerCopy(prompt, selectedAnswer, kind)

  const blocks = []
  if (question) {
    blocks.push({ type: 'markdown', content: question })
  }
  if (reply) {
    blocks.push({ type: 'markdown', variant: 'muted', content: reply })
  }
  if (blocks.length === 0) {
    blocks.push({
      type: 'markdown',
      content: `Sounds good — we'll create ${humanizeAgentQuestionSelection(selectedAnswer)}.`,
    })
  }
  return blocks
}
